// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/_enum-bug-keys.js
// module id = YNi7
// module chunks = 15